import { type } from '@mews/framework';
import ApiComponent from '../apiComponent';
import createRequest from './misc/createRequest';

const BASE_URL = '/tasks';

export default function TaskComponent(apiComponent: $TSFixMe) {
    type.check(apiComponent, ApiComponent);
    const request = createRequest(apiComponent.request, BASE_URL);

    return type.create(TaskComponent, {
        getAll({
            enterpriseId,
            createdUtc,
            startUtc,
            endUtc,
            deadlineUtc,
            closedUtc,
            state,
            serviceOrderIds,
            taskIds,
            extent,
        }: $TSFixMe) {
            return request('/getAll', {
                enterpriseId,
                createdUtc,
                startUtc,
                endUtc,
                deadlineUtc,
                closedUtc,
                state,
                serviceOrderIds,
                taskIds,
                extent,
            });
        },
        update({
            taskId,
            enterpriseId,
            departmentId,
            assigneeProfileId,
            name,
            description,
            serviceOrderId,
            deadlineUtc,
        }: $TSFixMe) {
            return request('/update', {
                taskId,
                enterpriseId,
                departmentId: { value: departmentId },
                assigneeProfileId: { value: assigneeProfileId },
                name: { value: name },
                description: { value: description },
                serviceOrderId: { value: serviceOrderId },
                deadlineUtc: { value: deadlineUtc },
            });
        },
        close({ taskIds }: $TSFixMe) {
            return request('/close', { taskIds });
        },
    });
}
